'use client';

import {
  resolveCustomData,
  CustomDataEntry,
} from '../../../../utils/meta/resolveCustomData';
import { trackConversion } from '../../../../utils/meta/trackConversion';

export interface MetaTrackingConfig {
  enabled: boolean;
  eventName?: string;
  customData?: CustomDataEntry[];
}

interface Args {
  formId?: string;
  /** Formatted submission values - what the placeholders resolve against. */
  values: Record<string, string>;
  config?: MetaTrackingConfig;
}

function extractEmail(values: Record<string, string>): string | undefined {
  return Object.values(values).find(
    (value) => typeof value === 'string' && value.includes('@'),
  );
}

/**
 * Await this before navigating away: the pixel event only fires once the
 * platform has had its say on the submission, and a redirect in between would
 * cut that short.
 */
export async function fireMetaConversion({
  formId,
  values,
  config,
}: Args): Promise<void> {
  if (!config?.enabled || !config.eventName) return;

  await trackConversion({
    eventName: config.eventName,
    formId,
    formValues: values,
    email: extractEmail(values),
    customData: resolveCustomData({ entries: config.customData, values }),
  });
}
